import type { ITooltipParams } from 'ag-grid-community';
import { Box } from '../../Core';
import { PopoverContent } from '../../Popover/PopoverContent';
import { Text } from '../../Text';

/**
 * Opt-in AG Grid tooltip for values that should render as one line per item.
 *
 * Use this when a column's visible cell should stay compact (for example comma-separated),
 * but its tooltip should be easier to scan as stacked text. The column should return the
 * tooltip lines from `tooltipValueGetter`, usually as `string[] | null`, and set
 * `tooltipComponent: AgGridLinesTooltip`.
 *
 * This component is intentionally separate from `AgGridTextTooltip` so existing text
 * tooltip behavior stays unchanged unless a column explicitly opts into this renderer.
 */
export function AgGridLinesTooltip({ value }: ITooltipParams<unknown, readonly string[] | null | undefined>) {
  if (!value?.length) {
    return null;
  }

  return (
    <PopoverContent>
      <Box maxWidth="300px">
        {value.map((line, index) => (
          <Text key={`${line}-${index}`} color="colorTextDefault" display="block">
            {line}
          </Text>
        ))}
      </Box>
    </PopoverContent>
  );
}
